import React, { SyntheticEvent, useState } from 'react'
import { Col, Row } from 'react-bootstrap'

import Button from '../../../Button'
import Dialog from '../../../Dialog'

type TCancelation = {
  id?: string
  cancelColi?: (id?: string) => void
}
const Cancelation = (props: TCancelation): React.ReactElement => {
  const { id, cancelColi } = props
  const [openDialog, setDialog] = useState(false)

  const handleDeleteClick = (e: SyntheticEvent): void => {
    if (e) e.stopPropagation()
    if (cancelColi) {
      cancelColi(id)
    }

    setDialog(false)
  }

  return (
    <React.Fragment>
      <Button danger onClick={() => setDialog(true)} icon="far fa-ban">
        {i18n.t('cancel_coli', 'Stornieren')}
      </Button>
      <Dialog
        show={openDialog}
        onHide={() => setDialog(false)}
        title={i18n.t('confirm_coli_cancel', 'Coli wirklich stornieren?')}
      >
        <Row>
          <Col md={12} className="d-flex justify-content-between">
            <Button variant="success" onClick={() => setDialog(false)}>
              <b>{i18n.t('cancel', 'Abbrechen')}</b>
            </Button>
            <Button
              variant="danger"
              onClick={(e: SyntheticEvent) => handleDeleteClick(e)}
            >
              <b>{i18n.t('confirm_cancelation', 'Ja, stornieren!')}</b>
            </Button>
          </Col>
        </Row>
      </Dialog>
    </React.Fragment>
  )
}

export default Cancelation
